import kitty_logo from "../images/kitty_party/kitty_logo.png";
import '../invitations/Invitation.css'

const kittyPartyInvitationElements = [

// TEXT CONTENT

{
id:11,
type:"text",
text:"🍹Kitty Party🍾",
x:10,
y:210,
fontSize:80,
fontFamily:"Dancing Script",
fill:"#d63384"
},
{
id:12,
type:"text",
text:"Hey Ladies! 💃",
x:200,
y:50,
fontSize:28,
fontFamily:"Dancing Script",
fill:"#d63384"
},
{
id:13,
type:"text",
text:"Let's get together for fun, laughter & games!",
x:60,
y:80,
fontSize:26,
fontFamily:"Dancing Script",
fill:"#d63384"
},
{
id:14,
type:"text",
text:"Hosted by: Sneha 💖",
x:140,
y:120,
fontSize:24,
fontFamily:"Raleway",
fill:"#d63384"
},
{
id:15,
type:"text",
text:"📅 Date: Sunday, 22/03/2026",
x:10,
y:400,
fontSize:22,
fontFamily:"Cardo",
fill:"#d63384"
},
{
id:16,
type:"text",
text:"⏰ Time: 04:00 PM onwards",
x:10,
y:430,
fontSize:22,
fontFamily:"Cardo",
fill:"#d63384"
},
{
id:17,
type:"text",
text:"📍 Venue:",
x:10,
y:500,
fontSize:22,
fontFamily:"Josefin Sans",
fill:"#d63384"
},
{
id:18,
type:"text",
text:"Green Garden Restaurant",
x:10,
y:530,
fontSize:20,
fontFamily:"Josefin Sans",
fill:"#d63384"
},
{
id:19,
type:"text",
text:"Vijayawada",
x:10,
y:560,
fontSize:20,
fontFamily:"Josefin Sans",
fill:"#d63384"
},
{
id:20,
type:"text",
text:"Get ready for games, gossip & yummy treats! 🍰",
x:30,
y:640,
fontSize:24,
fontFamily:"Dancing Script",
fill:"#d63384"
},
{
id:21,
type:"text",
text:"Don't miss the fun! 🎁",
x:160,
y:740,
fontSize:24,
fontFamily:"Great Vibes",
fill:"#d63384"
},
{
id:22,
type:"text",
text:"📞 Contact: 98765xxxxx",
x:170,
y:770,
fontSize:20,
fontFamily:"Great Vibes",
fill:"#d63384"
},
{
id:23,
type:"image",
src:kitty_logo,
x:300,
y:370,
width:280,
height:240
}
];

export default kittyPartyInvitationElements;